import { AxiosError } from 'axios';
import { useState } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  PaginatedResponse,
  SuccessHttpResponse,
} from '../../../../models/https';
import { invitedJobsActions } from '../../../../redux/slices/invitedJobsSlice';
import { useAppDisPatch, useAppSelector } from '../../../../redux/store';
import useHttps from '../../../useHttps';

interface InvitedJobsFilter {
  page?: string;
  perPage?: string;
  keyword?: string;
  location?: string;
  payInterval?: string;
}

const useGetInvitedJobs = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();
  const { authData } = useAppSelector((state) => state.auth);

  const onGetInvitedJobsError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching invited jobs'
    );
  };

  const getInvitedJobs = (filter?: InvitedJobsFilter) => {
    if (!authData?.id) return;
    const page = parseInt(filter?.page ?? '1', 10);
    const perPage = parseInt(filter?.perPage ?? '10', 10);

    let urlPath = `auth-service/users/${authData.id}/invitations/?limit=${perPage}&offset=${page}`;

    if (filter?.keyword) {
      urlPath += `&keyword=${encodeURIComponent(filter.keyword)}`;
    }
    if (filter?.location) {
      urlPath += `&location=${encodeURIComponent(filter.location)}`;
    }
    if (filter?.payInterval) {
      urlPath += `&payInterval=${encodeURIComponent(filter.payInterval)}`;
    }

    const url: HttpConfig = {
      url: urlPath,
      method: 'get',
    };

    const onGetInvitedJobsSuccess = (
      response: SuccessHttpResponse<PaginatedResponse>
    ) => {
      const {
        totalPages,
        totalElements,
        numberOfElements,
        first,
        last,
        content,
      } = response.data;

      dispatch(
        invitedJobsActions.updateInvitedJobs({
          page,
          perPage,
          totalPages,
          totalElements,
          numberOfElements,
          first,
          last,
          content,
        })
      );
    };

    return request(
      url,
      onGetInvitedJobsSuccess,
      setLoading,
      onGetInvitedJobsError
    );
  };

  return { getInvitedJobs, loading };
};

export default useGetInvitedJobs;
